import { useHistory } from 'react-router-dom';
import { isAfter, startOfDay } from 'date-fns';
import { useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handleRequest } from '~/infra/utils';
import { AdHocSendOption, mapFormToAdHocSubmitRequest, resolveSubmitSemantics } from '../AdHocBillModal.types';
import { useAdHocSubmitMutation } from './useAdHocSubmitMutation';
export const useAdHocSubmit = (param)=>{
    let { form, relationshipId, attachments, legalTerms, defaultEmailSubject, defaultEmailContent, dismissModal } = param;
    const { submitAdHoc: submitAdHocMutation, isLoading, isError } = useAdHocSubmitMutation();
    const { showErrorToast, showSuccessToast } = useOverlayContext();
    const { getNow } = useIoContext();
    const history = useHistory();
    const { t: adHocTexts } = useLocaleKeys('vendorOnboarding.adHocBillModal');
    const { t: commonTexts } = useLocaleKeys('common');
    const showSuccessToastForOption = (option, scheduledForFuture)=>{
        switch(option){
            case AdHocSendOption.SendByEmail:
                if (scheduledForFuture) {
                    showSuccessToast(commonTexts.toasts.chargesSuccessfullyScheduled(), 'ad-hoc-bill-schedule-success-toast');
                } else {
                    showSuccessToast(commonTexts.toasts.chargesSuccessfullyCreated(), 'ad-hoc-bill-send-success-toast');
                }
                return;
            case AdHocSendOption.MarkPaidExternally:
                showSuccessToast(commonTexts.toasts.invoiceIssuedAndMarkedAsExternallyPaid(), 'ad-hoc-bill-paid-externally-success-toast');
                return;
            case AdHocSendOption.ShareByLink:
                return;
        }
    };
    const submitAdHoc = async (option, onSuccess)=>{
        var _legalTerms_find;
        const data = form.getValues();
        if (data.items.length === 0) return false;
        // Re-derive against a fresh getNow() at submit time so a user who left the modal open across midnight does not get a wrong ScheduleBill vs BillNow classification — the form's isFutureIssueDate is for UI display only.
        const scheduledForFuture = isAfter(startOfDay(data.issueDate), startOfDay(getNow()));
        const semantics = resolveSubmitSemantics({
            option,
            isFutureIssueDate: scheduledForFuture
        });
        const selectedLegalTerm = (_legalTerms_find = legalTerms.find((lt)=>lt.id === data.termsOfServiceId)) !== null && _legalTerms_find !== void 0 ? _legalTerms_find : null;
        const request = mapFormToAdHocSubmitRequest({
            form: data,
            semantics,
            attachments: attachments.map((att)=>({
                    id: att.id,
                    displayName: att.displayName
                })),
            selectedLegalTerm,
            defaultEmailSubject,
            defaultEmailContent
        });
        const { success } = await handleRequest(submitAdHocMutation({
            relationshipId,
            data: request
        }));
        if (!success) {
            showErrorToast(adHocTexts.submitError(), 'ad-hoc-submit-error-toast');
            return false;
        }
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        if (option === AdHocSendOption.ShareByLink) return true;
        showSuccessToastForOption(option, scheduledForFuture);
        history.push(routes.invoices(relationshipId));
        dismissModal();
        return true;
    };
    return {
        submitAdHoc,
        isLoading,
        isError
    };
};
